<script lang="ts">
const __DsBlock = {
	icon: 'lucide:list-tree',
	name: '$t:blocks.collection_field_select.name',
	description: '$t:blocks.collection_field_select.description',
	category: 'system',
	tags: [],

	options: [
		{ name: 'modelValue', label: '$t:blocks.common.props.value', model: true },
		{ name: 'collectionId', label: '$t:blocks.common.props.collection' },
		{ name: 'includePrimitiveFields', label: '$t:blocks.collection_field_select.props.include_primitive_fields' },
		{ name: 'includeRelationFields', label: '$t:blocks.collection_field_select.props.include_relation_fields' },
	],
}
</script>
<script lang="ts" setup>
import type { GlobalCollectionId, GlobalPrimitiveFieldId, GlobalSingleRelationFieldId } from '#layers/data-model/public';

import { defineBlock } from '#layers/block-engine/public';
import { CollectionFieldSelect, useCollection } from '#layers/data-model/public';

interface Props {
	collectionId: GlobalCollectionId;
	includePrimitiveFields?: boolean;
	includeRelationFields?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
	includePrimitiveFields: true,
	includeRelationFields: true,
});

const modelValue = defineModel<GlobalPrimitiveFieldId | GlobalSingleRelationFieldId | null>({
	required: true,
});

const { collection } = useCollection(() => props.collectionId);

;
</script>

<template>
	<CollectionFieldSelect
		v-if="collection"
		v-model="modelValue"
		:collection
		:include-primitive-fields
		:include-relation-fields
	/>
</template>
